import { initializeSlider } from './initialize_link_list_slider_sections/initialize_slider';
import { onSliderSectionHeadlineClick, onSliderSectionNextClick, onSliderSectionPrevClick } from './initialize_link_list_slider_sections/on_slider_section_headline_click';

const sliderSectionHeadlineSelector = '.link-list-sliders__slider-section-headline';

export const initializeLinkListSliderSections = () => {
    const sliders = initializeSlider();

    $('.link-list-sliders').on(
        'click',
        '.slider-control--prev',
        onSliderSectionPrevClick(sliders)
    );
    
    $('.link-list-sliders').on(
        'click',
        '.slider-control--next',
        onSliderSectionNextClick(sliders)
    );

    $('.link-list-sliders').on(
        'click',
        sliderSectionHeadlineSelector,
        onSliderSectionHeadlineClick(sliders)
    );
};
